import { Link } from "react-router-dom";
import { Heart, ListMusic } from "lucide-react";
import { toast } from "sonner";
import { errMsg, http, mediaUrl } from "../lib/api";

export const Mosaic = ({ covers }) => (
  <div className="aspect-square rounded-2xl overflow-hidden border border-[var(--c-line)] grid grid-cols-2 grid-rows-2 bg-[var(--c-elev)]">
    {[0, 1, 2, 3].map((i) => covers[i]
      ? <img key={i} src={mediaUrl(covers[i])} alt="" className="w-full h-full object-cover" />
      : <div key={i} className="flex items-center justify-center"><ListMusic className="w-6 h-6 text-zinc-700" /></div>)}
  </div>
);

export const togglePlaylistLike = async (pl, setLists) => {
  try {
    const { data } = await http.post(`/playlists/${pl.id}/like`);
    setLists((ls) => ls.map((x) => (x.id === pl.id ? { ...x, likes: data.likes, liked: data.liked } : x)));
  } catch (e) { toast.error(errMsg(e)); }
};

const LikeBtn = ({ pl, onLike }) => (
  <button data-testid={`playlist-card-like-${pl.id}`} onClick={() => onLike(pl)}
    className={`flex items-center gap-1 transition-colors ${pl.liked ? "text-[var(--c-orange)]" : "hover:text-white"}`}>
    <Heart className="w-3.5 h-3.5" fill={pl.liked ? "currentColor" : "none"} />{pl.likes}
  </button>
);

export const PlaylistCard = ({ pl, index = 0, onLike, showOwner }) => (
  <div data-testid={`playlist-card-${pl.id}`} className="group rise" style={{ animationDelay: `${index * 40}ms` }}>
    <Link to={`/grojarastis/${pl.id}`} data-testid={`playlist-card-link-${pl.id}`} className="block">
      <div className="transition-transform duration-300 group-hover:-translate-y-1"><Mosaic covers={pl.covers || []} /></div>
      <p className="font-semibold mt-3 truncate group-hover:text-[var(--c-orange)] transition-colors">{pl.name}</p>
    </Link>
    {showOwner && pl.owner && (
      <Link to={`/autorius/${pl.owner.user_id}`} data-testid={`playlist-card-owner-${pl.id}`}
        className="block text-xs text-zinc-400 truncate hover:text-[var(--c-orange)] transition-colors">{pl.owner.name}</Link>
    )}
    <div className="flex items-center gap-3 mt-1 text-xs text-zinc-500">
      <span>{pl.count} dain.{pl.is_public ? "" : " · privatus"}</span>
      {onLike && !pl.is_mine ? <LikeBtn pl={pl} onLike={onLike} />
        : <span data-testid={`playlist-card-likes-${pl.id}`} className="flex items-center gap-1"><Heart className="w-3.5 h-3.5" />{pl.likes}</span>}
    </div>
  </div>
);
